import React, { useState, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const SearchInput = ({ onSearch, className = 'search-input', debounceTime = 300 }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const { t } = useTranslation();
  const inputRef = useRef(null);

  const debounce = useCallback((func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }, []);

  const debouncedSearch = useCallback((value) => {
    onSearch && onSearch(value);
  }, [onSearch]);

  // const handleSearchChange = () => {
  //   const value = e.target.value;
  //   setSearchTerm(value);
  //   debounce(debouncedSearch, debounceTime)(value);
  // };
   const handleSearchChange = () => {
    if (onSearch) {
      onSearch(searchTerm);
    }
  };

    const handleKeyDown = (e) => {
    // These keys indicate user is done with keyboard
    if (e.key === 'Enter' || e.key === 'Go' || e.key === 'Search' || e.key === 'Done') {
      // Trigger search immediately on Enter
      if (onSearch) {
        onSearch(searchTerm);
      }
      
      if (window.innerWidth <= 768) {
        // Blur the input to close keyboard
        e.target.blur();
        // Remove keyboard class immediately
        document.body.classList.remove('keyboard-open');
      }
    }
  };
  

  // Add focus/blur handlers to detect keyboard
  const handleFocus = () => {
    // Optionally notify parent about keyboard state
    if (window.innerWidth <= 768) {
      // This could trigger hiding the bottom menu
      document.body.classList.add('keyboard-open');
    }
  };

  const handleBlur = () => {
    if (window.innerWidth <= 768) {
      document.body.classList.remove('keyboard-open');
    }
  };

  return (
<>
  <div style={{ position: 'relative', display: 'inline-block', width: '100%',    maxWidth: '350px' }}>
    <input
      ref={inputRef}
      type="text"
      value={searchTerm}
      placeholder={t('Search...')}
      className={`${className} search-input`}
      onChange={(e) => setSearchTerm(e.target.value)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      style={{ 
        boxSizing: 'border-box', 
        paddingRight: '44px',
        paddingLeft: '12px',
        width: '100%'
      }}
      inputMode="search"
      enterKeyHint="search"
    />
    <button
      onClick={() => {
        if (onSearch) onSearch(searchTerm);
        if (window.innerWidth <= 768 && inputRef.current) {
          inputRef.current.blur();
          document.body.classList.remove('keyboard-open');
        }
      }}
      style={{
        position: 'absolute',
        right: '8px',
        top: '0',
        bottom: '0',
        margin: 'auto',
        height: '32px',
        width: '32px',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        transition: 'background-color 0.2s',
        zIndex: 2,
        flexShrink: 0
      }}
      aria-label={t('Search')}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block', flexShrink: 0 }}
      >
        <path
          d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
          fill="#666"
        />
      </svg>
    </button>
  </div>

  <style>{`
    .search-input {
      padding: 8px 44px 8px 12px !important;
      width: 100%;
      max-width: 400px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      background-color: white;
      font-size: 1rem;
      transition: all 0.2s;
      outline: none;
      display: block;
      box-sizing: border-box;
      -webkit-appearance: none;
      appearance: none;
    }

    .search-input:hover { border-color: #bdbdbd; }

    .search-input:focus {
      // border-color: #4a90e2;
      box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);
    }

    body.keyboard-open .mobile-bottom-menu { display: none !important; }

    @media (min-width: 1024px) {
      .search-input {
        max-width: 350px;
        padding: 10px 44px 10px 14px !important;
        font-size: 1rem;
      }
    }

    @media (min-width: 769px) and (max-width: 1023px) {
      .search-input {
        max-width: 300px;
        padding: 9px 44px 9px 12px !important;
        font-size: 0.95rem;
      }
    }

    @media (max-width: 768px) {
      .search-input {
        width: 100%;
        max-width: 100%;
        padding: 10px 44px 10px 12px !important;
        font-size: 16px;
      }
    }

    @supports (-webkit-touch-callout: none) {
      .search-input:focus {
        position: relative;
        z-index: 9998;
      }
    }
  `}</style>
</>
  );
};

export default SearchInput;